import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { isSystemMessage } from '../../../TeamChat.utils';
import TeamChatMessage from '../../../TeamChatMessage';
import TeamChatSystemMessage from '../../../TeamChatSystemMessage';
import {
  dateDividerLabelStyles,
  dateDividerStyles,
  unreadDividerLabelStyles,
  unreadDividerLineStyles,
  unreadDividerStyles,
} from '../../TeamChatMessageList.styles';
import { formatMessageDateLabel } from '../../TeamChatMessageList.utils';

const TeamChatMessageListItem = memo(
  ({
    message,
    chatId,
    currentUserId,
    members,
    replyParent,
    replyCount,
    isGrouped,
    isHighlighted,
    isPinned,
    shouldRenderDateDivider,
    shouldRenderUnreadDivider,
    currentDateKey,
    onReplyTo,
    onTogglePin,
  }) => {
    const dateDivider = shouldRenderDateDivider ? (
      <Box sx={dateDividerStyles}>
        <Box sx={dateDividerLabelStyles}>
          <Typography variant="medium12">{formatMessageDateLabel(currentDateKey)}</Typography>
        </Box>
      </Box>
    ) : null;

    const unreadDivider = shouldRenderUnreadDivider ? (
      <Box sx={unreadDividerStyles}>
        <Box sx={unreadDividerLineStyles} />
        <Box sx={unreadDividerLabelStyles}>
          <Typography variant="medium12">New messages</Typography>
        </Box>
        <Box sx={unreadDividerLineStyles} />
      </Box>
    ) : null;

    return (
      <React.Fragment>
        {dateDivider}
        {unreadDivider}
        {isSystemMessage(message) ? (
          <TeamChatSystemMessage message={message} />
        ) : (
          <TeamChatMessage
            chatId={chatId}
            currentUserId={currentUserId}
            isGrouped={isGrouped}
            isHighlighted={isHighlighted}
            isPinned={isPinned}
            members={members}
            message={message}
            replyCount={replyCount}
            replyParent={replyParent}
            onReplyTo={onReplyTo}
            onTogglePin={onTogglePin}
          />
        )}
      </React.Fragment>
    );
  },
);
TeamChatMessageListItem.propTypes = {
  message: PropTypes.object.isRequired,
  chatId: PropTypes.string,
  currentUserId: PropTypes.string,
  members: PropTypes.arrayOf(PropTypes.object),
  replyParent: PropTypes.object,
  replyCount: PropTypes.number,
  isGrouped: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isPinned: PropTypes.bool,
  shouldRenderDateDivider: PropTypes.bool,
  shouldRenderUnreadDivider: PropTypes.bool,
  currentDateKey: PropTypes.string,
  onReplyTo: PropTypes.func,
  onTogglePin: PropTypes.func,
};

export default TeamChatMessageListItem;
